import TableTabSkeleton from "@/components/v2/molecules/admin/shared/TableTabSkeleton";

const ExpensesTabSkeleton = () => (
  <TableTabSkeleton filterCount={6} tableColumns={12} rowCount={6} />
);

export default ExpensesTabSkeleton;
